import { ResponsiveHeatMap } from '@nivo/heatmap'

const HeatMap = ({ data /* see data tab */ }) => (
    <div style={{height:"100vh"} }>
        <ResponsiveHeatMap
            data={[
                {
                    "id": "Japan",
                    "data": [
                        {
                            "x": "Train",
                            "y": 61817
                        },
                        {
                            "x": "Subway",
                            "y": -27451
                        },
                        {
                            "x": "Bus",
                            "y": 20336
                        },
                        {
                            "x": "Car",
                            "y": 6581
                        },
                        {
                            "x": "Boat",
                            "y": -70322
                        },
                        {
                            "x": "Moto",
                            "y": 70259
                        },
                        {
                            "x": "Moped",
                            "y": 1148
                        },
                        {
                            "x": "Bicycle",
                            "y": -37733
                        },
                        {
                            "x": "Others",
                            "y": 55497
                        }
                    ]
                },
                {
                    "id": "France",
                    "data": [
                        {
                            "x": "Train",
                            "y": 99992
                        },
                        {
                            "x": "Subway",
                            "y": -34097
                        },
                        {
                            "x": "Bus",
                            "y": -68092
                        },
                        {
                            "x": "Car",
                            "y": 66242
                        },
                        {
                            "x": "Boat",
                            "y": 14169
                        },
                        {
                            "x": "Moto",
                            "y": 23298
                        },
                        {
                            "x": "Moped",
                            "y": -97445
                        },
                        {
                            "x": "Bicycle",
                            "y": 53506
                        },
                        {
                            "x": "Others",
                            "y": -30866
                        }
                    ]
                },
                {
                    "id": "US",
                    "data": [
                        {
                            "x": "Train",
                            "y": 35912
                        },
                        {
                            "x": "Subway",
                            "y": 57326
                        },
                        {
                            "x": "Bus",
                            "y": -52528
                        },
                        {
                            "x": "Car",
                            "y": 32467
                        },
                        {
                            "x": "Boat",
                            "y": -49111
                        },
                        {
                            "x": "Moto",
                            "y": 44518
                        },
                        {
                            "x": "Moped",
                            "y": -25398
                        },
                        {
                            "x": "Bicycle",
                            "y": 44169
                        },
                        {
                            "x": "Others",
                            "y": 90953
                        }
                    ]
                },
                {
                    "id": "Germany",
                    "data": [
                        {
                            "x": "Train",
                            "y": -87782
                        },
                        {
                            "x": "Subway",
                            "y": -81821
                        },
                        {
                            "x": "Bus",
                            "y": -67091
                        },
                        {
                            "x": "Car",
                            "y": -44717
                        },
                        {
                            "x": "Boat",
                            "y": -99514
                        },
                        {
                            "x": "Moto",
                            "y": -7003
                        },
                        {
                            "x": "Moped",
                            "y": -84874
                        },
                        {
                            "x": "Bicycle",
                            "y": 60622
                        },
                        {
                            "x": "Others",
                            "y": -1665
                        }
                    ]
                },
                {
                    "id": "Norway",
                    "data": [
                        {
                            "x": "Train",
                            "y": 34551
                        },
                        {
                            "x": "Subway",
                            "y": -14762
                        },
                        {
                            "x": "Bus",
                            "y": -88274
                        },
                        {
                            "x": "Car",
                            "y": 665
                        },
                        {
                            "x": "Boat",
                            "y": 83701
                        },
                        {
                            "x": "Moto",
                            "y": -99713
                        },
                        {
                            "x": "Moped",
                            "y": 66071
                        },
                        {
                            "x": "Bicycle",
                            "y": -1915
                        },
                        {
                            "x": "Others",
                            "y": -23252
                        }
                    ]
                },
                {
                    "id": "Iceland",
                    "data": [
                        {
                            "x": "Train",
                            "y": -63964
                        },
                        {
                            "x": "Subway",
                            "y": -44384
                        },
                        {
                            "x": "Bus",
                            "y": 97184
                        },
                        {
                            "x": "Car",
                            "y": -36839
                        },
                        {
                            "x": "Boat",
                            "y": 34665
                        },
                        {
                            "x": "Moto",
                            "y": -77476
                        },
                        {
                            "x": "Moped",
                            "y": -98170
                        },
                        {
                            "x": "Bicycle",
                            "y": -57431
                        },
                        {
                            "x": "Others",
                            "y": -48809
                        }
                    ]
                },
                {
                    "id": "UK",
                    "data": [
                        {
                            "x": "Train",
                            "y": 21577
                        },
                        {
                            "x": "Subway",
                            "y": 50206
                        },
                        {
                            "x": "Bus",
                            "y": -95058
                        },
                        {
                            "x": "Car",
                            "y": 99592
                        },
                        {
                            "x": "Boat",
                            "y": 57254
                        },
                        {
                            "x": "Moto",
                            "y": 17922
                        },
                        {
                            "x": "Moped",
                            "y": 25355
                        },
                        {
                            "x": "Bicycle",
                            "y": 53682
                        },
                        {
                            "x": "Others",
                            "y": -71622
                        }
                    ]
                },
                {
                    "id": "Vietnam",
                    "data": [
                        {
                            "x": "Train",
                            "y": -84526
                        },
                        {
                            "x": "Subway",
                            "y": 63942
                        },
                        {
                            "x": "Bus",
                            "y": 78140
                        },
                        {
                            "x": "Car",
                            "y": 96767
                        },
                        {
                            "x": "Boat",
                            "y": -76659
                        },
                        {
                            "x": "Moto",
                            "y": 53854
                        },
                        {
                            "x": "Moped",
                            "y": 41523
                        },
                        {
                            "x": "Bicycle",
                            "y": -25184
                        },
                        {
                            "x": "Others",
                            "y": 4617
                        }
                    ]
                }
            ]}
            margin={{ top: 60, right: 90, bottom: 60, left: 90 }}
            valueFormat=">-.2s"
            axisTop={{ tickRotation: -90 }}
            axisRight={{ legend: 'country', legendOffset: 70 }}
            axisLeft={{ legend: 'country', legendOffset: -72 }}
            colors={{
                type: 'diverging',
                scheme: 'red_yellow_blue',
                divergeAt: 0.5,
                minValue: -100000,
                maxValue: 100000
            }}
            emptyColor="#555555"
            legends={[
                {
                    anchor: 'bottom',
                    translateX: 0,
                    translateY: 30,
                    length: 400,
                    thickness: 8,
                    direction: 'row',
                    tickPosition: 'after',
                    tickSize: 3,
                    tickSpacing: 4,
                    tickOverlap: false,
                    tickFormat: '>-.2s',
                    title: 'Value →',
                    titleAlign: 'start',
                    titleOffset: 4
                }
            ]}
        />
    </div>
)
export default HeatMap;